// extracted by mini-css-extract-plugin
export default {"transactionCard":"styles_transactionCard__52KDK","iconBox":"styles_iconBox__B52Hs","content":"styles_content__1l322","left":"styles_left__aXRW-","right":"styles_right__SjgSX"};